import axios from "@/axios";

export const namespaced = true;

const defaultData = {
  orderId: 0,
  lineItemId: 0,
  itemNumber: null,
  fundCitationName: null,
  stockClassId: null,
  stockSubClassId: null,
  stockDescription: null,
  unitMeasureId: null,
  requestedQuantity: null,
  receivedQuantity: null,
  unitPrice: null,
};

export const state = {
  replacementItems: [],
  replacementItem: Object.assign({}, defaultData),
  replacementItemStatus: false,
  replacementItemEnabled: false,
  replacementItemErrors: [],
};

export const getters = {
  replacementItems: (state) => {
    let replacementItems = [];
    if (state.replacementItems) {
      let replacementItemNumbers = state.replacementItems
        .filter((replacementItem) => parseInt(replacementItem.itemNumber))
        .map((replacementItem) => {
          return {
            ...replacementItem,
            itemNumber: parseInt(replacementItem.itemNumber),
          };
        });

      let replacementItemStrings = state.replacementItems.filter(
        (replacementItem) => !parseInt(replacementItem.itemNumber)
      );

      replacementItemNumbers = replacementItemNumbers.sort();
      if (replacementItemStrings) {
        replacementItemStrings = replacementItemStrings.sort();
        replacementItems = replacementItemNumbers.concat(
          replacementItemStrings
        );
      } else {
        replacementItems = replacementItemNumbers;
      }

      return replacementItems;
    }
  },
  replacementItem: (state) => state.replacementItem,
  replacementItemStatus: (state) => state.replacementItemStatus,
  replacementItemEnabled: (state) => state.replacementItemEnabled,
  replacementItemErrors: (state) => state.replacementItemErrors,
};

export const mutations = {
  SET_REPLACEMENT_ITEM: (state, response) => {
    state.replacementItem = Object.assign({}, defaultData, response.data);
  },
  SET_REPLACEMENT_ITEMS: (state, response) => {
    // for (let index = 0; index < response.data.length; index++) {
    //   response.data[index].itemNumber = parseInt(
    //     response.data[index].itemNumber,
    //     10
    //   );
    state.replacementItems = response.data;
    // }
  },
  CLEAR_REPLACEMENT_ITEM_DATA: (state) => {
    state.replacementItem = Object.assign({}, defaultData);
  },
  SET_REPLACEMENT_ITEM_STATUS(state, status) {
    state.replacementItemStatus = status;
  },
  SET_REPLACEMENT_ITEM_ENABLED(state, response) {
    state.replacementItemEnabled = response.data;
  },
  CLEAR_SUB_CLASS: (state) => {
    state.replacementItem.stockSubClassId = null;
  },
  SET_ERRORS(state, data) {
    state.replacementItemErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.replacementItemErrors = [];
  }
};

export const actions = {
  async getReplacementItem({ commit }, id) {
      commit(
        "SET_REPLACEMENT_ITEM",
        await axios.get(`/api/replacementitems/${id}`)
      );
  },

  async getReplacementItems({ commit }, orderId) {
    commit(
      "SET_REPLACEMENT_ITEMS",
      await axios.get(`/api/replacementitems/order/${orderId}`)
    );
  },
  async getReplacementItemEnabled({ commit }, orderId) {
    commit(
      "SET_REPLACEMENT_ITEM_ENABLED",
      await axios.get(`/api/replacementitems/enabled/${orderId}`)
    );
  },
  async getReplacementItemStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_REPLACEMENT_ITEM_STATUS", false);
    } else {
      return await axios
        .get("/api/replacementitems/status/" + id)
        .then(({ data }) => {
          if(data && data.length === 0) {
            commit("SET_REPLACEMENT_ITEM_STATUS", true);
            commit("CLEAR_ERRORS");
        } else {
          commit("SET_REPLACEMENT_ITEM_STATUS", false);
            commit("SET_ERRORS", data);
        }
        });
    }
  },
  async ImportReplacementItems({ commit }, orderId) {
    return await axios
      .get("/api/replacementitems/import/" + orderId)
      .then(({ data }) => {
        commit("SET_REPLACEMENT_ITEMS", data);
      });
  },
  async saveReplacementItem({ state }, id) {
    state.replacementItem.orderId = id;
    return await axios.post("/api/replacementitems", state.replacementItem);
  },
  async removeReplacementItem({ commit, state }, id) {
    return await axios.delete(`api/replacementitems/${id}`, {config: {showToast: false}});
  },
  // Function to update replacement line items item number.
  async updateReplacementItemNumbers({}, items) {
    return await axios.post("/api/replacementitems/reorder", items);
  }, 
  clearStockSubClass({ commit }) {
    commit("CLEAR_SUB_CLASS");
  },
  clearReplacementItem({ commit }) {
    commit("CLEAR_REPLACEMENT_ITEM_DATA");
  },
};
